import React from "react";
import { DotLegalFixedHeightText, DotLegalLink, ToDto } from "@dotlegal/dotlegal-ui-components";
import TopBarTile from "./TopBarTile";

export interface ITopBarTextTileProps {
    label: string;
    isLoading?: boolean;
    value: React.ReactNode;
    // Destination of the tile: when set, the value renders as a DotLegalLink (a real anchor, so right/middle-click work).
    // Accepts an in-app route or an absolute url.
    linkTo?: ToDto | string;
    // Rich multi-line tiles (lists, stacked yes/date) render their own layout and don't want the ellipsis tooltip.
    neverShowTooltip?: boolean;
}

// Loading/height/ellipsis are owned by DotLegalFixedHeightText; the linked case wraps the value in a DotLegalLink
// so links render identically to the number tile.
function TopBarTextTile(props: ITopBarTextTileProps) {
    const content = props.linkTo ? (
        <DotLegalLink linkColor="primary" to={props.linkTo} bold>
            {props.value}
        </DotLegalLink>
    ) : (
        props.value
    );

    return (
        <TopBarTile label={props.label}>
            <DotLegalFixedHeightText
                isLoading={!!props.isLoading}
                content={content}
                neverShowTooltip={props.neverShowTooltip}
                // The text box clips what overflows it, and a selected chip draws its 1px border as an outline outside
                // its own box, so the value keeps that pixel of room to show the chip's whole border.
                sx={{ padding: "1px" }}
            />
        </TopBarTile>
    );
}

export default TopBarTextTile;
